module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-10.ae1b8c07.jpg";